// src/features/auth/signup/components/SignupField.tsx

import React from 'react';

interface SignupFieldProps {
  id: string;
  label: string;

  value: string;

  onChange: (
    value: string,
  ) => void;

  type?: React.HTMLInputTypeAttribute;

  placeholder?: string;

  autoComplete?: string;

  maxLength?: number;

  disabled?: boolean;

  required?: boolean;

  inputClassName: string;

  labelClassName: string;

  message?: string;

  messageType?:
    | 'default'
    | 'success'
    | 'error';
}

export default function SignupField({
  id,
  label,
  value,
  onChange,

  type = 'text',

  placeholder,

  autoComplete,

  maxLength,

  disabled = false,

  required = true,

  inputClassName,
  labelClassName,

  message,

  messageType = 'default',
}: SignupFieldProps) {
  const getMessageClassName =
    (): string => {
      switch (messageType) {
        case 'success':
          return 'text-emerald-600';

        case 'error':
          return 'text-red-600';

        default:
          return 'text-gray-500';
      }
    };

  return (
    <div>
      <label
        htmlFor={id}
        className={labelClassName}
      >
        {label}

        {required && (
          <span className="ml-1 text-red-500">
            *
          </span>
        )}
      </label>

      <input
        id={id}
        type={type}
        value={value}
        placeholder={placeholder}
        autoComplete={autoComplete}
        maxLength={maxLength}
        disabled={disabled}
        onChange={(event) =>
          onChange(
            event.target.value,
          )
        }
        className={inputClassName}
      />

      {message && (
        <p
          className={`mt-1.5 text-xs sm:mt-2 sm:text-sm ${getMessageClassName()}`}
        >
          {message}
        </p>
      )}
    </div>
  );
}